import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card } from "antd";
import { isMobileMode } from "../../../modules/configuration";
import {
  getInfoIntervento,
  getInfoInterventoStore,
  ID_PAZIENTE,
  DATA_INTERVENTO,
  ID_STRUTTURA,
  INGRESSO_BLOCCO_OPERATORIO,
  INGRESSO_SALA_OPERATORIA,
  USCITA_SALA_OPERATORIA,
  USCITA_BLOCCO_OPERATORIO,
  startPolling,
  stopPolling,
} from "../../../modules/surgery";
import { InfoUtente } from "./InfoUtente";
import { Timeline } from "./Timeline";
import { Legenda } from "./Legenda";
import moment from "moment";
import { withRouter } from "react-router";
import { PATH_HOME } from "../../../path";

const MonitoraBase = ({ history }) => {
  const dispatch = useDispatch();
  const infoInterventoStore = useSelector(getInfoInterventoStore);
  const infoIntervento = useSelector(getInfoIntervento);
  const mobileMode = useSelector(isMobileMode);

  useEffect(() => {
    return function cleanup() {
      window.removeEventListener("beforeunload", () => dispatch(stopPolling()), false);
    };
    // eslint-disable-next-line
  }, []);

  if (!infoIntervento || infoIntervento === undefined) history.push(PATH_HOME);

  if (
    infoIntervento &&
    infoIntervento[ID_PAZIENTE] &&
    infoIntervento[ID_PAZIENTE] !== undefined &&
    !infoInterventoStore.pollingStarted &&
    infoIntervento[DATA_INTERVENTO] &&
    infoIntervento[DATA_INTERVENTO] !== undefined &&
    (!infoIntervento[INGRESSO_BLOCCO_OPERATORIO] ||
      infoIntervento[INGRESSO_BLOCCO_OPERATORIO] === undefined ||
      !infoIntervento[INGRESSO_SALA_OPERATORIA] ||
      infoIntervento[INGRESSO_SALA_OPERATORIA] === undefined ||
      !infoIntervento[USCITA_SALA_OPERATORIA] ||
      infoIntervento[USCITA_SALA_OPERATORIA] === undefined ||
      !infoIntervento[USCITA_BLOCCO_OPERATORIO] ||
      infoIntervento[USCITA_BLOCCO_OPERATORIO] === undefined) &&
    moment(infoIntervento[DATA_INTERVENTO]).isSame(moment(), "day") &&
    moment(infoIntervento[DATA_INTERVENTO]).isSame(moment(), "month") &&
    moment(infoIntervento[DATA_INTERVENTO]).isSame(moment(), "year")
  )
    dispatch(startPolling(infoIntervento[ID_STRUTTURA], infoIntervento[ID_PAZIENTE]));

  useEffect(() => {
    // prettier-ignore
    if (infoIntervento && infoIntervento !== undefined &&
      infoIntervento[INGRESSO_BLOCCO_OPERATORIO] && infoIntervento[INGRESSO_BLOCCO_OPERATORIO] !== undefined &&
      infoIntervento[INGRESSO_SALA_OPERATORIA] && infoIntervento[INGRESSO_SALA_OPERATORIA] !== undefined &&
      infoIntervento[USCITA_SALA_OPERATORIA] && infoIntervento[USCITA_SALA_OPERATORIA] !== undefined &&
      infoIntervento[USCITA_BLOCCO_OPERATORIO] && infoIntervento[USCITA_BLOCCO_OPERATORIO] !== undefined &&
      infoInterventoStore.pollingStarted
    )
      dispatch(stopPolling());
  }, [infoIntervento, infoInterventoStore, dispatch]);

  return (
    <div className={mobileMode ? "monitoraggioMobile" : "monitoraggio"}>
      <h1>Surgery Tracker - Monitoraggio Intervento</h1>
      {infoIntervento && infoIntervento !== undefined && (
        <Card
          {...(infoIntervento[ID_PAZIENTE] && infoIntervento[ID_PAZIENTE] !== undefined && { title: <InfoUtente info={infoIntervento} /> })} //prettier-ignore
          bordered={false}
          actions={[<Legenda />]}
        >
          <Timeline info={infoIntervento} />
        </Card>
      )}
    </div>
  );
};

export const Monitora = withRouter(MonitoraBase);
